import axios, { AxiosError } from 'axios'

import { setAppError } from '@/redux/app/appLegacyActions'
import { TypedDispatch } from '@/redux/store'
import { setToast } from '@/redux/toasts/toastsReducer'
import { ToastType } from '@/types'

interface ApiErrorDetail {
    detail?: string
}

// After upgrading to Symphony 4.3 the API wouldn't accept any patch calls with a slash
// at the end. This interceptor will fix that
const removeSlashAtEndOfUrl = (url: string): string => {
    if (url.charAt(url.length - 1) === '/') {
        return url.substr(0, url.length - 1)
    }

    return url
}

export class AppInterceptor {
    store: { dispatch: TypedDispatch }

    constructor(store: { dispatch: TypedDispatch }) {
        this.store = store
    }

    setInterceptors = (): void => {
        axios.interceptors.request.use((config) => {
            config.url = removeSlashAtEndOfUrl(config.url || '')

            return config
        })

        // Error code handling
        axios.interceptors.response.use(
            response => response,
            (error: AxiosError<{ meta?: unknown, errors?: ApiErrorDetail[] }>) => {
                const { dispatch } = this.store

                if (error.response?.status === 500) {
                    dispatch(setAppError({
                        code: 500,
                        message: error.response.data?.meta,
                    }))
                }

                if (error.response?.status === 422) {
                    const errors = error.response.data?.errors
                    const detail = (errors && errors[0]) ? errors[0].detail : ''
                    dispatch(setToast({
                        text: detail || '',
                        type: ToastType.fail,
                    }))
                }

                return Promise.reject(error)
            },
        )
    }
}
